import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhoSection() {
  return <section className="py-24 bg-blush/20 relative" data-id="element-66">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-67">
        <div className="text-center mb-16" data-id="element-68">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-brown mb-2 italic" data-id="element-69">
            ¿Eres tú?
          </h2>
          <div className="section-divider-gold" data-id="element-70"></div>
          <p className="text-lg text-brown-light max-w-2xl mx-auto mt-6" data-id="element-71">
            No queremos que gastes ni un dólar si esto no es exactamente lo que
            necesitas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-16" data-id="element-72">
          {/* YES Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-10 rounded-2xl border-l-4 border-green-400 shadow-xl" data-id="element-73">
            <h3 className="text-2xl font-serif font-bold text-green-800 mb-8 flex items-center gap-3" data-id="element-74">
              <CheckCircle2 className="w-8 h-8" data-id="element-75" />
              SÍ es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-76">
              {['Tienes un talento manual (cocina, costura, artesanía) y quieres sacarle provecho.', 'Necesitas ingresos extra pero no puedes cumplir horarios fijos fuera de casa.', 'Te sientes intimidada por la tecnología complicada pero sabes usar WhatsApp.', "Vives en Estados Unidos y quieres dólares, no 'likes'.", 'Quieres sentirte útil, productiva y orgullosa de tu propio dinero.'].map((item, i) => <li key={i} className="flex items-start gap-4 text-brown-light text-lg" data-id="element-77">
                  <div className="w-2 h-2 rounded-full bg-green-500 mt-2.5 flex-shrink-0" data-id="element-78" />
                  <span data-id="element-79">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* NO Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/50 p-10 rounded-2xl border-l-4 border-red-300" data-id="element-80">
            <h3 className="text-2xl font-serif font-bold text-red-800 mb-8 flex items-center gap-3" data-id="element-81">
              <XCircle className="w-8 h-8" data-id="element-82" />
              NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-83">
              {['Buscas una fórmula mágica para hacerte rica de la noche a la mañana.', 'No tienes ningún interés en aprender cosas nuevas, aunque sean sencillas.', 'Crees que la tecnología es el enemigo y te niegas a usar tu celular.', 'Esperas que los clientes caigan del cielo sin hacer tu parte.', 'No estás dispuesta a invertir el precio de un café en tu educación.'].map((item, i) => <li key={i} className="flex items-start gap-4 text-brown-light text-lg" data-id="element-84">
                  <div className="w-2 h-2 rounded-full bg-red-400 mt-2.5 flex-shrink-0" data-id="element-85" />
                  <span data-id="element-86">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="text-center mt-12" data-id="element-87">
          <div className="inline-block bg-gold text-white px-6 py-2 rounded-full font-bold text-sm shadow-md uppercase tracking-wide" data-id="element-88">
            Si te identificas con el lado izquierdo → este método fue hecho para
            ti.
          </div>
        </div>
      </div>
    </section>;
}